import React from 'react';

const ButtonBlock = ({ data, onChange }) => {
  return (
    <div className="basic-form">
      <div className="mb-3">
        <label className="form-label">Button Text</label>
        <input
          type="text"
          className="form-control"
          placeholder="Button text..."
          value={data.text}
          onChange={(e) => onChange({ ...data, text: e.target.value })}
        />
      </div>
      
      <div className="mb-3">
        <label className="form-label">Button URL</label>
        <input
          type="url"
          className="form-control"
          placeholder="https://example.com"
          value={data.url}
          onChange={(e) => onChange({ ...data, url: e.target.value })}
        />
      </div>
    </div>
  );
};

export default ButtonBlock;
